import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import ModalConstants from 'app/shared/constants/ModalConstants';

import ModalActions from 'app/shared/actions/ModalActions';

import {
    Alert,
    Spacer,
    Text,
    TextButton,
} from '@zillow/constellation';

import { RMWContext } from 'app/shared/providers/RMWContext';

const propTypes = {
    formData: PropTypes.shape({
        feedName: PropTypes.string.isRequired,
        listingAlias: PropTypes.string.isRequired,
        isFeed: PropTypes.bool.isRequired,
        active: PropTypes.bool.isRequired,
        topDupesDetails: PropTypes.shape({
            hasManualDupe: PropTypes.bool.isRequired,
            sourceCount: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
};

const FeedListingSourceBanner = ({ formData }) => {
    const dispatch = useDispatch();
    const {
        feedName,
        isFeed,
        active,
        listingAlias,
        topDupesDetails: {
            hasManualDupe,
            sourceCount,
        },
    } = formData;
    const { paths } = React.useContext(RMWContext);
    if (!isFeed) {
        return null;
    }

    const handleGoToListingSource = () => {
        window.router.transitionTo(`${paths.propertiesPage}/${listingAlias}/${paths.propertyDetailsSources}`);
    };

    const handleCreateNewVersion = () => {
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.TRANSFER_FEED_LISTING_MODAL,
            header: 'Automatically create a new version',
            isFluid: true,
            onCloseModal: () => dispatch(ModalActions.hideModal()),
            onCancel: () => dispatch(ModalActions.hideModal()),
        }));
    };

    let bodyText;
    let ctaText;
    let handleOnClick;
    if (!hasManualDupe) {
        bodyText = `${feedName} is the source for this version of the listing. To edit the information,
            go to ${feedName}, or copy and create a new version you can edit directly in Zillow Rental Manager.
            The new version will not be automatically published.`;
        ctaText = 'Automatically create a new version';
        handleOnClick = handleCreateNewVersion;
    } else if (active) {
        bodyText = `${feedName} is the source for this version of the listing,
            which is currently visible to renters. To change the listing source,
            publish the version of the listing you want users to see.`;
        ctaText = 'Manage listing sources';
        handleOnClick = handleGoToListingSource;
    } else {
        bodyText = `${feedName} is the source for this version of the listing,
            which is not currently visible to renters. The address has ${sourceCount} listing sources.`;
        ctaText = 'Manage listing sources';
        handleOnClick = handleGoToListingSource;
    }

    const body = <Text fontType="body">{bodyText}</Text>;

    return (
        <Spacer marginBottom="md">
            <Alert
                appearance="info"
                body={body}
                actionButton={<TextButton onClick={handleOnClick}>{ctaText}</TextButton>}
            />
        </Spacer>
    );
};

FeedListingSourceBanner.propTypes = propTypes;

export { FeedListingSourceBanner };
export default FeedListingSourceBanner;
